import { memo, useEffect } from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'

import { initializeTagTrackingManager } from 'nexchange-service/module/seo'

import config from '@/config'

const { DOMAIN } = config

const SEO = ({ title, description, fullTitle = false }) => {
    const finalTitle = fullTitle ? title : `${title} - easywallet`
    const { locales, asPath } = useRouter()

    useEffect(() => {
        initializeTagTrackingManager()
    }, [])

    return (
        <Head>
            <meta charSet="utf-8" />
            <meta name="viewport" content="initial-scale=1.0, width=device-width" />

            <title>{finalTitle}</title>
            <meta name="description" content={description} />

            <meta property="og:title" content={finalTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="business.business" />
            <meta
                property="og:image"
                content="https://easywallet.io/images/logo/icons/logo-easywallet.svg"
            />

            <meta name="twitter:title" content={finalTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content="https://n.exchange/img/expand.png" />

            <link rel="icon" sizes="180x180" href="/images/logo/icons/logo-easywallet.svg" />
            <link
                rel="icon"
                type="image/png"
                sizes="32x32"
                href="/images/logo/icons/logo-easywallet.svg"
            />
            <link
                rel="icon"
                type="image/png"
                sizes="16x16"
                href="/images/logo/icons/logo-easywallet.svg"
            />
            <link rel="manifest" href="/manifest.json" />
            <link rel="mask-icon" href="/images/logo/icons/logo-easywallet.svg" color="#6b73b1" />

            <meta name="msapplication-TileColor" content="#6b73b1" />
            <meta name="theme-color" content="#6b73b1" />

            {locales &&
                locales.map(lang => (
                    <link
                        key={lang}
                        rel="alternate"
                        hrefLang={lang}
                        href={`${DOMAIN}/${lang}${asPath !== '/' ? asPath : ''}`}
                    />
                ))}

            <link rel="preconnect" href="https://fonts.googleapis.com" />
            {/* @ts-ignore */}
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
            <link
                href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@200;400;500;600;700&display=swap"
                rel="stylesheet"
                as="style"
            />
        </Head>
    )
}

export default memo(SEO)
